import React from 'react';
import EmbedPage from 'src/shared/components/EmbedPage/EmbedPage';
import { OPTIONS } from './constants/uiThemesOptions';

export default function UiThemes({ productSelected }) {
  return <EmbedPage options={OPTIONS} productSelected={productSelected}></EmbedPage>;
}
